// const config = [
//   {
//     id: "04",
//     title: "Принести води",
//     rule: {
//       type: "staticdate",
//       func: 'return date.getDay() === 1 || date.getDay() === 5',
//     },
//   },
//   {
//     id: "05",
//     title: "Піти в спортзал",
//     rule: {
//       type: "staticdate",
//       func: 'return date.getDay() === 2 || date.getDay() === 4 || date.getDay() === 6',
//     },
//   },
//   {
//     id: "06",
//     title: "Попрати простинь (і ЗАПИСАТИ В ЩОДЕННИК)",
//     rule: {
//       type: "frequency",
//       frequency: 45,
//     },
//   },
//   {
//     id: "13",
//     title: "Спланувати фінанси і зняти готівку",
//     rule: {
//       type: "staticdate",
//       func: "return date.getDate() === 10",
//     },
//   },
//   {
//     id: "14",
//     title: "Вставити заготовки google tasks",
//     rule: {
//       type: "staticdate",
//       func: "return date.getDate() === 5",
//     },
//     link: "/task_generator",
//   },
//   {
//     id: "18",
//     title: "Постригтись",
//     rule: {
//       type: "frequency",
//       frequency: 21,
//     },
//   },
// ];

const config = [
  {
    id: "19",
    title: "Пробіжка",
    rule: {
      type: "frequency",
      frequency: 2,
    },
  },
  {
    id: "20",
    title: "Workout",
    rule: {
      type: "frequency",
      frequency: 2,
    },
  },
  {
    id: "21",
    title: "Брийся",
    rule: {
      type: "frequency",
      frequency: 5,
    },
  },
];

export default config;
